var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.947266,
    y: 0.947021,
    width: 134.106,
    height: 134.106,
    rx: 67.0529,
    fill: "#575E76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3335 94.6666V73.3333M49.3335 73.3333V46.6666M49.3335 73.3333L55.922 72.0156C60.3234 71.1353 64.8858 71.5542 69.0533 73.2212C73.5694 75.0276 78.54 75.365 83.2588 74.1853L83.8307 74.0423C85.4975 73.6256 86.6668 72.1279 86.6668 70.4098V50.7644C86.6668 48.6829 84.7107 47.1556 82.6913 47.6605C78.3414 48.7479 73.7594 48.437 69.5963 46.7717L69.0533 46.5545C64.8858 44.8875 60.3234 44.4686 55.922 45.3489L49.3335 46.6666M49.3335 46.6666V41.3333",
    stroke: "#272A39",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup2);
export default __webpack_public_path__ + "static/media/startup-2.e77bfa75ea79a53286cb87f0ae6b9f88.svg";
export { ForwardRef as ReactComponent };